import { Component, OnInit, Inject, inject } from "@angular/core";
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from "@angular/material/snack-bar";


@Component({
  selector: "app-custom-snack-bar",
  templateUrl: "./custom-snack-bar.component.html",
  styleUrls: ["./custom-snack-bar.component.css"],
})
export class CustomSnackBarComponent implements OnInit {

  progress = 100;
  private currentIntervalId: NodeJS.Timeout;

  snackBarRef = inject(MatSnackBarRef);
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {
  }

  ngOnInit() {
    const duration = this.data.duration;
    this.runProgressBar(duration ?? 0);
  }

  get icon() {
    switch (this.data.snackType) {
      case "Success":
        return "check_circle";
      case "Error":
        return "error";
      case "Warn":
        return "warning";
      case "Info":
        return "help";
      default:
        return "error";
    }
  }

  get color() {
    switch (this.data.snackType) {
      case "Success":
        return "primary";
      case "Error":
        return "warn";
      case "Warn":
        return "accent";
      case "Info":
        return "info";
    }
  }

  runProgressBar(duration: number) {
    this.progress = 100;
    const step = 0.01;
    this.cleanProgressBarInterval();
    this.currentIntervalId = setInterval(() => {
      this.progress -= 100 * step;
      if (this.progress < 0) {
        this.cleanProgressBarInterval();
      }
    }, duration * step);
  }

  cleanProgressBarInterval() {
    clearInterval(this.currentIntervalId);
  }

  fecha()
  {
    this.cleanProgressBarInterval();
    this.snackBarRef.dismiss();
  }
}
